module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-05-23e69b3b.webp";